<template>
  <div id="app" :class="{ 'has-tabbar': showTabBar }">
    <router-view />
    <CommonTabbar v-if="showTabBar" />
  </div>
</template>

<script>
import {
  enable as enableDarkMode
} from 'darkreader'
import CommonTabbar from '@/components/common-tabbar.vue'
import { TAB_BAR_PATHS } from '@/config/tabbar'

export default {
  name: 'App',
  components: {
    CommonTabbar
  },
  computed: {
    showTabBar() {
      return TAB_BAR_PATHS.includes(this.$route.path)
    }
  },
  mounted() {
    // 暗黑模式初始化
    document.documentElement.setAttribute('data-theme', 'light')
    const theme = uni.getStorageSync('theme')
    if (theme === 'dark') {
      try {
        enableDarkMode({ brightness: 140, contrast: 100, sepia: 0, grayscale: 5 })
      } catch (e) { /* ignore */ }
    }

    // 打开 WebSocket
    this.$store.dispatch('openSocket')
  },
  beforeDestroy() {
    this.$store.dispatch('clearnSocket')
  }
}
</script>

<style>
@import url('vant/lib/index.css');

#app.has-tabbar {
  padding-bottom: calc(58px + env(safe-area-inset-bottom));
  box-sizing: border-box;
}

.van-toast {
  z-index: 9999999;
}

.common-btn-color {
  background-color: #f1a802;
  color: #fff;
}
</style>
